module.exports = require('./helpers/bundle-url').getBundleURL('8a2ir') + "logo.c51670a8.svg";